
/**
 * @Name: 酒店资源配置 service
 */

import request from '../request'
import apis from '../apis'

export default {

    /**
     * 获取酒店资源列表数据
     * @param {*} pageVO
     * @param {*} params
     */
    getHotelResourcesList({ pageVO, params }) {
        return request.get(`${apis.GET_HOTEL_RESOURCES_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 设置酒店是否启用
     * @param {*} pageVO
     * @param {*} params
     */
    setHotelIsEnable(params) {
        return request.post(apis.SET_HOTEL_IS_ENABLE, params)
    },

    /**
     * 设置酒店是否推荐
     * @param {*} pageVO
     * @param {*} params
     */
    setHotelIsHot(params) {
        return request.post(apis.SET_HOTEL_IS_HOT, params)
    },

    /**
     * 删除酒店资源列表数据
     * @param {*} pageVO
     * @param {*} params
     */
    deleteHotelResourcesData(params) {
        return request.post(apis.DELETE_HOTEL_RESOURCES_DATA, params)
    },

    /**
     * 获取房型列表数据
     * @param {*} pageVO
     * @param {*} params
     */
    getRoomTypeListData(params) {
        return request.get(apis.GET_ROOM_TYPE_LIST, { params });
    },

    /**
     * 获取差旅房型数据
     * @param {*} pageVO
     * @param {*} params
     */
    getItravelRoomTypeData(params) {
        return request.get(apis.GET_ITRAVEL_ROOM_TYPE_LIST, { params });
    },

    /**
     * 导出酒店资源列表数据
     * @param {*} params
     */
    exportHotelResourcesData(params) {
        return request.get(apis.EXPORT_HOTEL_RESOURCES_DATA, { params });
    },

    /**
     * 导出房型房量数据
     * @param {*} params
     */
    exportRoomData(params) {
        return request.get(apis.EXPORT_ROOM_DATA, { params });
    },

    /**
     * 导入房型房量数据
     * @param {*} params
     */
    importRoomData({ params, formData }) {
        return request.post(`${apis.IMPORT_ROOM_DATA}?ulType=EventsgoExcelImport&excelType=eventsgo.hotelRoomType&modelType=hotel&exhiId=${params.exhiId}`, formData)
    },

    /**
     * 新增房型数据
     * @param {*} params
     */
    addRoomTypeData(params) {
        return request.post(apis.ADD_ROOM_TYPE_DATA, params)
    },

    /**
     * 编辑房型数据
     * @param {*} params
     */
    modifyRoomTypeData(params) {
        return request.post(apis.MODIFY_ROOM_TYPE_DATA, params)
    },

    /**
     * 获取房型详情数据
     * @param {*} params
     */
    getRoomDetailData(params) {
        return request.get(apis.GET_ROOM_DETAIL_DATA, { params });
    },

    /**
     * 删除房型数据
     * @param {*} params
     */
    deleteRoomTypeData(params) {
        return request.post(`${apis.DELETE_ROOM_TYPE_DATA}/${params}`)
    },

    /**
     * 获取房量列表数据
     * @param {*} pageVO
     * @param {*} params
     */
    getRoomQuantityListData(params) {
        return request.get(apis.GET_ROOM_QUANTITY_LIST, { params });
    },

    /**
     * 校验房量数据
     * @param {*} params
     */
    checkOrderHotelRoomVolumeSer(params) {
        return request.post(apis.CHECK_ORDER_HOTEL_ROOM_VOLUME, params)
    },

    /**
     * 保存房量数据
     * @param {*} params
     */
    saveRoomQuantityData(params) {
        return request.post(apis.SAVE_ROOM_QUANTITY_DATA, params)
    },

    /**
     * 获取酒店相关数据字典配置数据
     * @param {*} params
     */
    getHotelLookupData(params) {
        return request.get(apis.HOTEL_LOOKUP_DATA, { params });
    },

    /**
     * 获取酒店相关数据字典配置数据：爱上会
     * @param {*} params
     */
    getHotelLookupForCommon(params) {
        return request.get(apis.COMMON_LOOKUP_DATA, { params });
    },

    /**
     * 上传图片
     * @param {*} params
     */
    uploadImage(params, stparams) {
        let api = `${apis.UPLOAD_IMAGE}${stparams.attType ? '&attType=' + stparams.attType : ''}${stparams.thumbFlag ? '&thumbFlag=' + stparams.thumbFlag : ''}`
        if (stparams.compressPress) {
            api += '&compressPress=' + stparams.compressPress
        }
        return request.post(api, params)
    },

    /**
     * 获取酒店详情 - 酒店基本信息
     */
    findConfigHotelDetails({ params }) {
        return request.get(`${apis.FIND_CONFIG_HOTEL_DETAILS}`, { params });
    },

    /**
     * 获取酒店详情 - 房型列表
     */
    getDetailRoomTypeListData({ params, pageVO }) {
        return request.get(`${apis.GET_DETAIL_ROOM_TYPE_LIST_DATA}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 获取酒店详情 - 房量列表
     */
    getDetailRoomNumListData({ params, pageVO }) {
        return request.get(`${apis.GET_DETAIL_ROOM_NUM_LIST_DATA}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 获取酒店详情 - 房量列表数据统计
     */
    getDetailRoomNumCount({ params }) {
        return request.get(`${apis.GET_DETAIL_ROOM_NUM_COUNT}`, { params });
    },

    /**
     * 获取酒店详情 - 房量信息 - 酒店所配置的房型列表
     */
    findRoomTypeNamesList({ params }) {
        return request.get(`${apis.FIND_ROOM_TYPE_NAMES_LIST}`, { params });
    },

    /* 获取酒店详情 - 酒店概况 */
    findHotelOverview({ params }) {
        return request.get(`${apis.FIND_HOTEL_OVERVIEW}`, { params });
    },

    /* 获取隐私声明 - 隐私详情 */
    getPrivacyStatement() {
        return request.get(`${apis.PRIVACY_STATEMENT}`)
    },

    /** ============================= 新增酒店 ============================= **/
    /**
     * 新增酒店差旅列表
     */
    findItravelHotelPagedList({ params, pageVO }) {
        return request.get(`${apis.FIND_ITRAVEL_HOTEL_PAGE_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 新增酒店差旅酒店详情
     */
    findItravelHotelDetail(params) {
        return request.get(apis.FIND_ITRAVEL_HOTEL_DETAIL, { params });
    },

    /**
     * 新增酒店资源库详情
    */
    findzykHotelDetail(params) {
        return request.get(apis.QUERY_HOTEL_SERVICE, { params });
    },

    /**
     * 新增酒店 - 资源库酒店列表
     */
    findRspHotelPageList({ params, pageVO }) {
        return request.get(`${apis.FIND_RSPHOTEL_PAGE_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 新增酒店 - 保存酒店
     */
    findAddHotel(params) {
        return request.post(`${apis.FIND_ADD_HOTEL}`, params)
    },

    /**
     * 酒店编辑
     */
    findSaveHotel(params) {
        return request.post(`${apis.FIND_SAVE_HOTEL}`, params)
    },

    /**
     * public  locpup配置
     */
    getPubilcCommon(params) {
        return request.get(apis.PUBLIC_LOOKUP_DATA_COMMON, { params });
    },

    /**
     * 公用方法获取电话号码
     */
    findPerson(params) {
        return request.get(`${apis.FIND_PERSON}`, { params });
    },

    /**
     * 位置区域
     */
    getLocationCommon(params) {
        return request.get(`${apis.FIND_LOCATION_COMMON}`, { params });
    }

    /** ============================= 新增酒店 ============================= **/
}
